// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QBPZb","insideBox":"styles_insideBox__5bj8s"};